import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

/**
 * Bordered tip-card used on the Start-Page in two configurations:
 *   - Default ("Ein kleiner Tipp für dich!") with a trailing
 *     underlined nav-Link to /inspiration.
 *   - New-user ("Willkommen!") with body copy and NO link slot.
 *
 * Same card shell in both cases — only the props differ. White bg,
 * yellow border, 16px padding, rounded-lg. Body text at opacity-50
 * per Sönke's secondary-text convention.
 */
export interface TipSectionProps {
  heading: string;
  body: string;
  /** Optional nav link rendered below the body as an underlined
   *  react-router `<Link>`. Omit for the new-user welcome variant. */
  link?: { label: string; to: string };
  className?: string;
  testId?: string;
}

export function TipSection({ heading, body, link, className, testId }: TipSectionProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-start gap-4 rounded-lg border border-dream-gold bg-dream-white p-4',
        className,
      )}
      data-testid={testId}
    >
      <div className="flex w-full flex-col items-start gap-3">
        <p className="text-sm font-semibold leading-[14px] text-dream-navy">{heading}</p>
        <p className="w-full text-xs leading-5 text-dream-navy opacity-50">{body}</p>
      </div>
      {link && (
        <Link
          to={link.to}
          className="w-full text-xs font-semibold leading-3 text-dream-navy underline decoration-solid"
        >
          {link.label}
        </Link>
      )}
    </div>
  );
}
